import { StatusFilter } from "@views/classrooms/details/components/classroom.modules.utils";
import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

export const SimulationStatus = {
  Started: "Started",
  Mastered: "Mastered",
  NeedsWork: "Needs Work",
  Stuck: "Stuck",
  All: "View All",
};

let SimulationStatusMap = null;

const initializeSimulationStatusMap = () => {
  if (SimulationStatusMap) return SimulationStatusMap;

  SimulationStatusMap = new Map();
  SimulationStatusMap.set("STARTED", {
    key: "Started",
    statusFilter: StatusFilter.Started,
    label: SimulationStatus.Started,
    description: `Sims that have been mastered, need work, or where the ${getLearnerTerm(
      { lowercase: true }
    )} is stuck.`,
    icon: "fa-person-running",
  });
  SimulationStatusMap.set("MASTERED", {
    key: "Mastered",
    statusFilter: StatusFilter.Mastered,
    label: SimulationStatus.Mastered,
    description: `The ${getLearnerTerm({
      lowercase: true,
    })} has completed the sim and received a score of 90% or higher.`,
    icon: "fa-medal",
  });
  SimulationStatusMap.set("NEEDS WORK", {
    key: "NeedsWork",
    statusFilter: StatusFilter.InProgress,
    label: SimulationStatus.NeedsWork,
    description: `The ${getLearnerTerm({
      lowercase: true,
    })} has started the sim but hasn't achieved mastery yet.`,
    icon: "fa-user-hard-hat",
  });
  SimulationStatusMap.set("STUCK", {
    key: "Stuck",
    statusFilter: StatusFilter.Stuck,
    label: SimulationStatus.Stuck,
    description: `The ${getLearnerTerm({
      lowercase: true,
    })} has not made progress in improving their sim score.`,
    icon: "fa-hand",
  });
  SimulationStatusMap.set("ALL", {
    key: "All",
    statusFilter: StatusFilter.All,
    label: SimulationStatus.All,
    description: "All sims regardless of status.",
    icon: "fa-list",
  });

  return SimulationStatusMap;
};

export function getSimulationStatus(status) {
  const map = initializeSimulationStatusMap();
  return map.get(status.toUpperCase());
}

export function getSimulationStatuses() {
  const map = initializeSimulationStatusMap();
  return [...map.values()];
}

export const AllSimulationStatuses = Object.values(SimulationStatus);
